import React from 'react';
import {includes} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';
import {Table, Checkbox, Popup, Icon, Modal} from 'semantic-ui-react';
import moment from 'moment';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {ordersStatus, ordersColors} from '../../../common/dictionaries/accessories';
import {findValueInObjectsArray} from '../../../common/util/array';
import {Actions} from '../../../common/actions';
import TechnicianAssignment from './modal/technicianAssignment';
import CancelOrder from './modal/cancel';
import {Link} from 'react-router-dom';

const {changeChassisMarked, changeOrdersMarked, fecthComboAccessoriesList} = Actions;

const getInvoiceType = (anticipatedInvoice) => {
  return anticipatedInvoice && anticipatedInvoice === 'S' ? 'ANTICIPADA' : 'NORMAL';
};

const StockDownloadIcon = ({order, type, openStockDownloadModal}) => {
  if (!order.status || type === 'pds' || (order.anticipatedInvoice === 'N' &&
    (order.status === ordersStatus.created_order || order.status === ordersStatus.assigned_technicians))) {
    return null;
  }

  return (
    <Popup
      trigger={
        <span className='link'>
          <Icon
            name='download'
            size='big'
            color={(order.status === ordersStatus.wash_wait ||
              (order.anticipatedInvoice === 'S' &&
              order.status === ordersStatus.created_order)) ? 'grey' : 'green'}
            onClick={() => openStockDownloadModal(order)}
          />
        </span>
      }
      content='Descarga de Stock'
      position='top center'
      inverted
    />
  );
};

const CancelOrderItem = ({order, type, filtersState}) => {
  const createdOrder = ordersStatus.created_order;
  const washWait = ordersStatus.wash_wait;
  const assignedTechnicians = ordersStatus.assigned_technicians;
  // const closedNotBillable = ordersStatus.closed_order_not_billable;
  const anticipatedInvoicedOrder = ordersStatus.anticipated_invoiced_order;
  if ((order.anticipatedInvoice === 'S' &&
        order.status === anticipatedInvoicedOrder && order.worked === 'S') ||
      ((order.anticipatedInvoice === 'N' || order.anticipatedInvoice === null) &&
        (order.status === createdOrder || order.status === assignedTechnicians)) ||
      (type === 'accessories' && order.status === washWait) ||
      (type === 'pds' && order.order)) {
    return <CancelOrder accessoryOrder={order} type={type} filters={filtersState} />;
  }
  return null;
};

const WorkedOrder = ({order}) => {
  if (order.worked !== 'S') {
    return null;
  }
  return (
    <Popup inverted position='bottom left' on='click'
      trigger={<Icon name='check' color='green' size='large' />}>
      <div><p>ORDEN TRABAJADA</p></div>
    </Popup>);
};

const TableDetailBody = ({
  type,
  chassisMarked,
  ordersMarked,
  ordersFiltered,
  orderStatusList,
  openStockDownloadModal,
  filtersState,
}) => {
  const dispatch = useDispatch();
  const comboAccessories = useSelector((state) => state.comboAccessories.list);

  const isRowMarked = (chassis) => {
    return includes(chassisMarked, chassis);
  };

  const getOrderColor = (status, worked) => {
    if (status === ordersStatus.anticipated_invoiced_order && worked === 'S') {
      return ordersColors[ordersStatus.invoiced_order];
    }
    return ordersColors[status];
  };

  const updateValuesMarked = (type, checked, value) => {
    const newArray = type === 'chassis' ? [...chassisMarked] : [...ordersMarked];
    const index = newArray.indexOf(value);

    if (checked) {
      if (index === -1) {
        newArray.push(value);
        if (type === 'chassis') {
          dispatch(changeChassisMarked(newArray));
        } else {
          dispatch(changeOrdersMarked(newArray));
        }
      }
    } else {
      if (index !== -1) {
        newArray.splice(index, 1);
        if (type === 'chassis') {
          dispatch(changeChassisMarked(newArray));
        } else {
          dispatch(changeOrdersMarked(newArray));
        }
      }
    }
  };

  const onOrderItemCheckboxChange = (checked, order) => {
    updateValuesMarked('chassis', checked, order.chassis);
    if (order.order) {
      updateValuesMarked('order', checked, order.order);
    }
  };

  const onOpenAccesoriesModal = (e, combo) => {
    e.preventDefault();
    dispatch(fecthComboAccessoriesList(combo));
  };

  const renderStatusName = (status) => {
    if (!status) {
      return '';
    }
    return findValueInObjectsArray(
      orderStatusList,
      {'keySearch': 'id', 'valueSearch': status},
      'description'
    );
  };

  const renderComboValue = (order) => {
    return (
      <Table.Cell>
        <Modal size='large'
          trigger={
            <div className='flex'>
              <Link className='w-100'>{order.combo}</Link>
              {order?.orderPlaced && order?.orderPlaced !== 'NO' &&
                <Popup
                  trigger={<Icon color='green' name='check circle' link />}
                  content='Pedido de accesorios realizado' />}
            </div>
          }
          onOpen={(e) => onOpenAccesoriesModal(e, order.combo)}
          content={
            <Table compact textAlign='center'>
              <Table.Header>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Accesorio</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
              </Table.Header>
              <Table.Body>
                {comboAccessories.length === 0 &&
                  <Table.Row><Table.Cell>Combo sin accesorios</Table.Cell></Table.Row>}
                {comboAccessories && comboAccessories.map((acc) => {
                  return (
                    <Table.Row>
                      <Table.Cell>{acc.code}</Table.Cell>
                      <Table.Cell>{acc.name}</Table.Cell>
                      <Table.Cell>{acc.quantity}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          } />
      </Table.Cell>
    );
  };

  const renderDate = (date) => {
    return date ? date.substring(0, 10) : null;
  };

  const renderRequestStateIcon = (order) => {
    return !order.request ? <Icon name='box' bordered color='grey'/> :
      <Popup inverted position='bottom left' on='click'
        trigger={
          <Icon link name='box' bordered color={order.delivery === 'S' ? 'green' : 'yellow'} />
        }>
        <div>
          <div>Pedido: <strong>{order.request}</strong></div>
          <div>Estado: <strong>{order.delivery === 'S' ? 'ENTREGADO' : 'PEDIDO'}</strong></div>
          <div>Fecha pedido: <strong>
            {moment(order.requestDate).format(dateFormatShow)}
          </strong></div>
          {order.delivery === 'S' ?
            <>
              <div>Fecha entrega:
                <strong> {moment(order.deliveryDate).format(dateFormatShow)}</strong>
              </div>
              <div>Entregado por: <strong>{order.deliveryUser}</strong></div>
            </> : ''
          }
        </div>
      </Popup>;
  };

  if (!ordersFiltered.length) {
    return (
      <Table.Body>
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={15}>
            No hay órdenes
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  return (
    <Table.Body>
      {ordersFiltered.map((order, index, list) => {
        const isNegative = !order.tasks && !order.order && type === 'accessories';
        const colorData = getOrderColor(order.status, order.worked);
        const styles = colorData ?
          {'backgroundColor': colorData.background, 'color': colorData.color} :
          {};
          
        return (
          <Table.Row key={index} negative={isNegative} style={styles}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell textAlign='center'>
              <Checkbox id={`chassis-checkbox-${index}`}
                disabled={type === 'accessories' && !order.tasks}
                checked={isRowMarked(order.chassis)}
                onChange={(e, {checked}) =>
                  onOrderItemCheckboxChange(checked, order)
                }
              />
            </Table.Cell>
            {filtersState.invoiceType === 'S' ? <Table.Cell>{renderRequestStateIcon(order)}</Table.Cell> : ''}
            <Table.Cell>{order.dealer}</Table.Cell>
            <Table.Cell>{order.agency}</Table.Cell>
            <Table.Cell>{order.location}</Table.Cell>
            <Table.Cell>{order.parkingSlot}</Table.Cell>
            <Table.Cell>{order.description}</Table.Cell>
            <Table.Cell>{order.chassis}</Table.Cell>
            <Table.Cell>{order.color}</Table.Cell>
            <Table.Cell>{renderDate(order.movementDate)}</Table.Cell>
            <Table.Cell>{renderDate(order.date)}</Table.Cell>
            {renderComboValue(order)}
            <Table.Cell textAlign='center'>{getInvoiceType(order.anticipatedInvoice)}</Table.Cell>
            <Table.Cell className='order-code' textAlign='center'>
              {order.order}
            </Table.Cell>
            <Table.Cell>{renderStatusName(order.status)}</Table.Cell>
            <Table.Cell textAlign='center' className='actions-column' style={{'paddingLeft': 0, 'paddingRight': 0}}>
              <TechnicianAssignment accessoryOrder={order} type={type} filters={filtersState} />
            </Table.Cell>
            <Table.Cell textAlign='center' className='actions-column' style={{'paddingLeft': 0, 'paddingRight': 0}}>
              <StockDownloadIcon
                order={order}
                type={type}
                openStockDownloadModal={openStockDownloadModal}
              />
            </Table.Cell>
            <Table.Cell textAlign='center' className='actions-column' style={{'paddingLeft': 0, 'paddingRight': 0}}>
              <CancelOrderItem order={order} type={type} filtersState={filtersState} />
            </Table.Cell>
            <Table.Cell textAlign='center' className='actions-column' style={{'paddingLeft': 0, 'paddingRight': 0}}>
              <WorkedOrder order={order} />
            </Table.Cell>
          </Table.Row>
        );
      })}
    </Table.Body>
  );
};

export default TableDetailBody;
